import { ITabProps } from "./type"
import { Nav, NavItem, NavLink } from "react-bootstrap"
import styles from './tabNavbar.styles.module.scss'
import { useEffect, useRef, useState } from "react"

const TabNavbar = (props: ITabProps) => {
    const { tabs, activeTab, onTabChange } = props
    const [isOverflow, setIsOverflow] = useState<boolean | null>(null)
    const scrollRef = useRef<HTMLDivElement>(null)
    const onChange = (e: React.MouseEvent<HTMLElement>) => {
        const target = e.target as unknown as { id: string }
        onTabChange(target.id)
    }
    const onLeft = () => {
        scrollRef && scrollRef.current?.scrollBy(-200, 0)
    }
    const onRight = () => {
        scrollRef && scrollRef.current?.scrollBy(200, 0)
    }
    useEffect(() => {
        const { current } = scrollRef
        if (current) {
            const hasOverflow = current.scrollWidth > current.clientWidth
            document.getElementById(activeTab)?.scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" })
            setIsOverflow(hasOverflow)
        }
        return () => { }
    }, [activeTab, scrollRef])

    return (
        <div className={styles.tabBar}>
            {isOverflow && <button className={styles.leftIcon} onClick={onLeft}>{"<"} </button>}
            <Nav ref={scrollRef} className={`${styles.tabWrap} ${isOverflow && styles.isOverFlowTab}`}>
                {tabs.map((tab, index) => {
                    return (
                        <NavItem key={"tab_" + index} className={`${styles.navlinkWrapper}`}>
                            <NavLink className={activeTab.includes(tab.id) ? `${styles.activeLink}` : ''}
                                id={tab.id}
                                onClick={onChange}
                                disabled={tab.disabled}
                            > {tab.name}
                            </NavLink>
                        </NavItem>
                    )
                })}
            </Nav>
            {isOverflow && <button className={styles.rightIcon} onClick={onRight}>{">"} </button>}
        </div>
    )
}

export default TabNavbar